import React, { Component } from 'react'
import tracking from '../utils/tracking'
import Helmet from 'react-helmet'

import './404.scss'

class NotFound extends Component {
  componentDidMount () {
    tracking.event('404', {
      is404: true,
      pagePath: `/404${window.location.pathname + window.location.search}`
    })
  }

  render () {
    return (
      <div className='msg404__container'>
        <Helmet>
          <title>Page not found</title>
          <script src='../utils/agegate-404.js' />
        </Helmet>
        <div className='msg404__wrap'>
          <h1>404 page not found</h1>
        </div>
      </div>
    )
  }
}

export default NotFound



// WEBPACK FOOTER //
// ./src/components/404.js